var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.66,31.2v20.89c0,3.38-2.74,6.12-6.12,6.12H17.46c-3.38,0-6.12-2.74-6.12-6.12V31.2H52.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.47,11.11c0.27-0.01,0.54-0.02,0.88,0.01c0.1,0.02,0.14,0.01,0.17,0c1.2,0.27,1.7,0.61,1.71,1.99 c0.02,2.57,0.03,5.15-0.02,7.72c-0.01,0.57,0.25,0.92,0.59,1.22c2.05,1.76,4.13,3.49,6.18,5.25c1.42,1.22,2.83,2.45,4.2,3.72 c1.05,0.97,1.07,2.44,0.15,3.46c-0.92,1.02-2.49,1.13-3.56,0.24c-1.26-1.06-2.5-2.14-3.75-3.22c-5.57-4.8-11.14-9.6-16.71-14.4 c-1.86-1.61-3.72-3.21-5.59-4.81c-0.72-0.62-0.73-0.62-1.47,0.02c-5.77,4.97-11.55,9.94-17.32,14.91 c-2.88,2.48-5.75,4.96-8.63,7.44c-1.12,0.96-2.73,0.86-3.66-0.21c-0.95-1.09-0.84-2.65,0.3-3.64c5.41-4.68,10.84-9.35,16.26-14.03 c3.96-3.41,7.92-6.82,11.88-10.23c0.96-0.83,2.58-1.01,3.42-0.33c0.99,0.81,1.95,1.66,2.92,2.5c1.53,1.32,3.06,2.64,4.59,3.96 c0.87,0.75,1.75,1.5,2.77,2.38c0-0.76,0-1.38,0-2c0.01-1.18,0.51-1.76,1.78-1.91C46.59,11.16,47.53,11.13,48.47,11.11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a3f1daf8c7b7aa0578ecbe8743266992.svg";
export { ForwardRef as ReactComponent };